export enum BackgroundColorType {
  // Formerly used materialize.css colors: http://materializecss.com/color.html
  DANGER = <any>'danger-red',
  INFO = <any>'info-blue',
  SUCCESS = <any>'success-green',
}
